import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { theme } from '@/assets/styles/variables.scss';
export default {
  props: {
    color: {
      type: String,
      default: theme
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  name: 'gl-button',
  data: function data() {
    return {
      num: 0,
      list: [],
      glButton: this.$refs.Glbutton
    };
  },
  computed: {
    disabledCtr: function disabledCtr() {
      return this.disabled || this.loading;
    },
    classStyle: function classStyle() {
      var disable = this.disabledCtr ? 'gl-disabled' : '';
      return "".concat(disable, " gl-button-").concat(this.type);
    }
  },
  methods: {
    handlerClick: function handlerClick(e) {
      var _this = this;
      this.num++;
      var parentPosition = this.$refs.Glbutton.getBoundingClientRect();
      var position = {
        x: e.x - parentPosition.x + 'px',
        y: e.y - parentPosition.y + 'px',
        key: this.num
      };
      this.list.push(position);
      setTimeout(function () {
        _this.list.shift();
      }, 1000);
      this.$emit('click', e);
    }
  }
};